import { useMutation } from '@tanstack/react-query';
import { useSubmitOrderApiV2 } from '@/clients/order/order.ts';
import { v4 as uuidv4 } from 'uuid';
import { useMemo } from 'react';

export function getUseSubmitOrderV2QueryKey() {
    return ['submit-order-v2'];
}

export const useSubmitOrderV2 = () => {
    const { submitOrderV2 } = useSubmitOrderApiV2();
    const idempotencyKey = useMemo(() => uuidv4(), []);

    return useMutation({
        mutationKey: getUseSubmitOrderV2QueryKey(),
        mutationFn: (body: Parameters<typeof submitOrderV2>[0]) => {
            return submitOrderV2(body, idempotencyKey);
        },
    });
};
